import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, startWith, distinctUntilChanged } from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import 'moment/locale/it';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../services/utils.service';
import { AlgConditionModalComponent } from '../../components/dialogs/alg-condition-modal/alg-condition-modal.component';
import { AlgConsensoService, REQUEST_STATUS_INVALID, REQUEST_STATUS_OK } from '../../services/alg-consenso.service';
import { LocationStrategy } from '@angular/common';
import { Fisso, RequestType, Status } from '../../models/fisso';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'alg-consent-fisso-request',
  templateUrl: './alg-consent-fisso-request.html',
  styleUrls: ['./alg-consent-fisso-request.scss'],
})
export class AlgConsensoFissoRequestComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  public isConsentsOk: boolean;

  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };

  public fisso: Fisso = {} as Fisso;
  public fissoResult: any;
  public cteMonthInUrl: any;
  public cteMonthInString: number;
  public invalidMonthOfCte: boolean;
  public product: any;

  public goNextStep: boolean;
  public docsReceptionCheckboxConsent: boolean;
  public supplyStartCheckboxConsent: boolean;
  public generalConditionCheckboxConsent: boolean;

  public consentsWithAdditionalProperty: any;
  public isOtpChecked: boolean;
  public secondStep: boolean;
  public invalidGeneralCondition = {
    consents: false,
    clause: false,
  };
  public cteLink: string;
  public cgfLink: string;
  public dataCTEFromUrl: string;
  public actualMonth: number;
  public contractForm: FormGroup;

  private ngUnsubscribe = new Subject<void>();

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;

  public checkboxGeneralCondition = {
    checkboxConsents: false,
    docsReceptionCondition: false,
    supplyStartCondition: false,
    generalCondition: false,
  };

  // TEXT PART
  public textField = {
    label1: 'Il Cliente sottoscrivendo per adesione la presente proposta accetta che in relazione alla fornitura di ',
    label2: 'a lui intestata verrà applicata la nuova Tipologia Offerta: Accendi Ecologica',
    label3: 'con riferimento CTE: ',
    label3a: 'la cui data di decorrenza nuova offerta sarà il ',
    label4: 'Con la sottoscrizione per adesione alla presente proposta, tramite firma elettronica semplice (FES), il Cliente:',
    label5:
      "accetta la modifica della Tipologia offerta in relazione alla/e fornitura/e sopra indicata/e nei termini e condizioni della presente Proposta di Cambio Piano e che l'Allegato B Condizioni Tecniche Economiche per la fornitura di ",
    label6: 'qui disponibile sostituisca quello precedentemente in vigore;',
    label7:
      "dichiara di conoscere e accettare le ulteriori condizioni contrattuali, costituite dalla Proposta di cambio Piano e dai relativi Allegati (oltre all'Allegato B- Condizioni Tecniche Economiche sopra nominato anche l’Allegato A - Condizioni Generali per la fornitura qui disponibile, che ne formano parte integrante e sostanziale;",
    label9:
      "Per tutto quanto non modificato con la presente, restano validi i consensi e le ulteriori informazioni fornite all'interno del modulo di Adesione alla Proposta di fornitura in fase di sottoscrizione iniziale del contratto, o come modificate in vigenza di contratto. ",
    label10:
      'Puoi prendere visione di tutti i dettagli nell’Allegato B - Condizioni tecniche economiche (CTE) e nell’Allegato A - Condizioni generali di fornitura.',
    label12: 'Il Cliente, inoltre:',
    label13:
      'dichiara di aver ricevuto preliminarmente alla sottoscrizione della presente proposta di Cambio Piano, anche all’interno dell’e-mail ricevuta e contenente il link per la sottoscrizione, tutte le informazioni precontrattuali nonché le condizioni contrattuali (Modulo di Adesione alla proposta di fornitura, Condizioni Generali di fornitura, Condizioni tecnico economiche, Scheda Sintetica) e dichiara di averne preso visione e di accettarle.',
    label14: 'In particolare, il Cliente:',
  };

  private month = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy
  ) {
    this.isLoading$ = this.consensoService.isLoading$;
    this.consensoService.initializeFissoRequest();
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.fisso.temporaryUrl = window.location.href;
      this.fisso.idRichiesta = params.id; // accountId
      this.fisso.contractId = params.codice; //contractId
      this.fisso.firstNameAndSurname = params.firstName + ' ' + params.lastName;
      this.fisso.clientPod = params.pod;
      this.fisso.clientPdr = params.pdr;
      this.fisso.dataCTE = params.dataCTE;
      this.fisso.phone_number = params.tel.includes('+39') ? params.tel.slice(3) : params.tel;
      this.fisso.email = params.email;
      this.fisso.clientCF = params.cf;
      this.fisso.duration = params.durata;
      this.fisso.monorarioBiorarioPWR = params.tariffa.charAt(0).toUpperCase() + params.tariffa.slice(1);
      this.dataCTEFromUrl = params.dataCTE;
      this.fisso.tariffa = params.tariffa.charAt(0).toUpperCase() + params.tariffa.slice(1);

      this.addTwoMonthsFromDateCTE(params.dataCTE);

      this.actualMonth = new Date().getMonth() + 1;

      // in case it is mono-gas
      if (this.fisso.tariffa === 'null') {
        this.fisso.monorarioBiorarioPWR = null;
      }

      if (this.fisso.clientPod !== 'null') {
        this.fisso.isLight = !this.fisso.isLight;
      }

      if (this.fisso.clientPdr !== 'null') {
        this.fisso.isGas = !this.fisso.isGas;
      }

      this.fisso.isDual = this.fisso.isGas && this.fisso.isLight;

      switch (this.fisso.duration) {
        case '12':
          if (this.fisso.isLight && !this.fisso.isGas) {
            this.fisso.contractType = 'EE-12';
            this.fisso.requestType = RequestType.monoLight;
            this.fisso.durataPWR = this.fisso.duration;
            this.fisso.durataGAS = null;
          }
          if (this.fisso.isLight && this.fisso.isGas) {
            this.fisso.contractType = 'DUAL-12';
            this.fisso.requestType = RequestType.dual;
            this.fisso.durataGAS = this.fisso.duration;
            this.fisso.durataPWR = this.fisso.duration;
          }
          if (!this.fisso.isLight && this.fisso.isGas) {
            this.fisso.contractType = 'GAS-12';
            this.fisso.requestType = RequestType.monoGas;
            this.fisso.durataPWR = null;
            this.fisso.durataGAS = this.fisso.duration;
          }
          break;
        case '24':
          if (this.fisso.isLight && !this.fisso.isGas) {
            this.fisso.contractType = 'EE-24';
            this.fisso.requestType = RequestType.monoLight;
            this.fisso.durataPWR = this.fisso.duration;
            this.fisso.durataGAS = null;
          }
          if (this.fisso.isLight && this.fisso.isGas) {
            this.fisso.contractType = 'DUAL-24';
            this.fisso.requestType = RequestType.dual;
            this.fisso.durataPWR = this.fisso.duration;
            this.fisso.durataGAS = this.fisso.duration;
          }
          if (!this.fisso.isLight && this.fisso.isGas) {
            this.fisso.contractType = 'GAS-24';
            this.fisso.requestType = RequestType.monoGas;
            this.fisso.durataPWR = null;
            this.fisso.durataGAS = this.fisso.duration;
          }
          break;
      }

      this.consensoService.checkFissoRequestContractId(params.codice);
      this.consensoService.isSecontStepFissoRequest$.subscribe((step) => {
        this.secondStep = step;
      });
      this.consensoService.isOtpAgileRequest$.subscribe((checked) => {
        this.isOtpChecked = checked;
      });

      this.fisso.cteLink = `https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/fisso/${this.fisso.monthOfCTE}-${this.fisso.yearOfCTE}/ALLB-CTE-ECO-${this.fisso.contractType}-ALG.pdf`;
    });

    this.consensoService.fissoRequestResult$.subscribe((result) => {
      this.fissoResult = result.prospectInfo;
      this.consentsWithAdditionalProperty = {
        AccountId: `${this.fisso.idRichiesta}`,
        ContractId: `${this.fisso.contractId}`,
        durata: `${this.fisso.duration}`,
        requestType: `${this.fisso.requestType}`,
        Alg_OTPCheck__c: false,
        Alg_OTPCheckDate__c: '',
        Alg_OTPPhone__c: '',
        phone: `${this.fisso.phone_number}`,
        clientName: `${this.fisso.firstNameAndSurname}`,
        email: `${this.fisso.email}`,
        fiscalCode: `${this.fisso.clientCF}`,
        Stato: Status.ko,
        linkCTE: `${this.fisso.cteLink}`,
        linkCGF: `${this.fisso.cgfLink}`,
        DataDecorrenza: `${this.invertDateFormat(this.fisso.dataCTE)}`,
        durataPWR: `${this.fisso.durataPWR}`,
        durataGAS: `${this.fisso.durataGAS}`,
        monorarioBiorarioPWR: `${this.fisso.monorarioBiorarioPWR}`,
        dataCTE: `${this.invertDateFormat(this.dataCTEFromUrl)}`,
      };

      // If actual month is greater than in the URL
      if (this.cteMonthInUrl < this.actualMonth) {
        this.invalidMonthOfCte = true;
        if (this.fissoResult === null || this.fissoResult === undefined) {
          this.consensoService.saveFissoRequest(this.consentsWithAdditionalProperty);
        }

        // If actual month is greater than in the URL but User has never signed it
        if (!!this.fissoResult && this.fissoResult.Alg_OTPCheck__c === false) {
          return;
        }
      }

      // If users enters the first time
      if ((this.fissoResult === null || this.fissoResult === undefined) && this.cteMonthInUrl >= this.actualMonth) {
        this.consensoService.saveFissoRequest(this.consentsWithAdditionalProperty);
      }
    });

    this.isRequestOk$ = this.consensoService.fissoRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorGeneric$ = this.consensoService.fissoRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );
    this.contractForm = new FormGroup({
      docsReceptionCondition: new FormControl(this.checkboxGeneralCondition.docsReceptionCondition, {
        validators: [Validators.requiredTrue],
      }),
      supplyStartCondition: new FormControl(this.checkboxGeneralCondition.supplyStartCondition, {
        validators: [Validators.requiredTrue],
      }),
      generalCondition: new FormControl(this.checkboxGeneralCondition.generalCondition, {
        validators: [Validators.requiredTrue],
      }),
    });
    this.contractForm.valueChanges.subscribe((data) => {
      this.checkboxGeneralCondition.docsReceptionCondition = data.docsReceptionCondition;
      this.docsReceptionCheckboxConsent = !data.docsReceptionCondition;
      this.checkboxGeneralCondition.generalCondition = data.generalCondition;
      this.generalConditionCheckboxConsent = !data.generalCondition;
      this.checkboxGeneralCondition.supplyStartCondition = data.supplyStartCondition;
      this.supplyStartCheckboxConsent = !data.supplyStartCondition;
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  private addTwoMonthsFromDateCTE(date) {
    // Get from URL the month and transform it in number
    this.cteMonthInString = parseInt(date.substring(3, 5));
    // Inversione data e mese
    let splitDate = date.split('-');
    splitDate = new Date(splitDate[2], parseInt(splitDate[1], 10) - 1, splitDate[0]);

    let month = splitDate.getMonth();

    let year = splitDate.getFullYear();

    month = parseInt(month + 1);
    this.cteMonthInUrl = month;

    this.fisso.yearOfCTE = parseInt(date.substring(6, 11));
    this.fisso.monthOfCTE = this.month[this.cteMonthInString - 1].toLowerCase();

    if (month <= 10) {
      let advancedMonth = month + 2;

      if (advancedMonth >= 10) {
        this.replaceBetween(3, 5, `${advancedMonth}`, this.fisso.dataCTE);
      } else {
        this.replaceBetween(3, 5, `0${advancedMonth}`, this.fisso.dataCTE);
      }
    }

    if (month === 11) {
      this.replaceBetween(3, 5, '01', this.fisso.dataCTE);
      this.fisso.dataCTE = this.fisso.dataCTE.replace(`${year}`, `${this.fisso.yearOfCTE + 1}`);
    }

    if (month === 12) {
      this.replaceBetween(3, 5, '02', this.fisso.dataCTE);
      this.fisso.dataCTE = this.fisso.dataCTE.replace(`${year}`, `${this.fisso.yearOfCTE + 1}`);
    }

    this.fisso.dataCTE = this.replaceBetween(0, 2, '01', this.fisso.dataCTE);
  }

  // Convert date format
  private invertDateFormat(date) {
    return date.split('-').reverse().join('-');
  }

  // Replace at a certain index the month of the dataCTE
  private replaceBetween(start, end, month, date) {
    return (this.fisso.dataCTE = date.substring(0, start) + month + date.substring(end));
  }

  public readCondition(type) {
    let modalContent;
    if (type === 'dataConsent') {
      modalContent = this.feedbackModalContent;
    }
    this.openModal(modalContent || {});
  }

  // feedback
  public onFeebackModal(event) {
    if (event === 'open') {
      this.readCondition('dataConsent');
    }
  }

  public openOTPmodal() {
    if (!this.goNextStep) {
      if (!this.checkboxGeneralCondition.checkboxConsents || !this.checkboxGeneralCondition.docsReceptionCondition) {
        this.invalidGeneralCondition.consents = true;
        this.scrollOnInvalidElement('generalInvalid');
      }
      return;
    }
    this.utils.disableOverflow();
    if (this.goNextStep) {
      this.consentsWithAdditionalProperty = {
        AccountId: `${this.fisso.idRichiesta}`,
        ContractId: `${this.fisso.contractId}`,
        durata: `${this.fisso.duration}`,
        requestType: `${this.fisso.requestType}`,
        Alg_OTPCheck__c: false,
        Alg_OTPCheckDate__c: '',
        Alg_OTPPhone__c: '',
        phone: `${this.fisso.phone_number}`,
        clientName: `${this.fisso.firstNameAndSurname}`,
        email: `${this.fisso.email}`,
        fiscalCode: `${this.fisso.clientCF}`,
        linkCTE: `${this.fisso.cteLink}`,
        linkCGF: `${this.fisso.cgfLink}`,
        DataDecorrenza: `${this.invertDateFormat(this.fisso.dataCTE)}`,
        durataPWR: `${this.fisso.durataPWR}`,
        durataGAS: `${this.fisso.durataGAS}`,
        monorarioBiorarioPWR: `${this.fisso.tariffa}`,
        dataCTE: `${this.invertDateFormat(this.dataCTEFromUrl)}`,
      };
      this.isConsentsOk = true;
      const htmlPage = document.getElementById('agileText').innerHTML;
      const textPage = document.getElementById('agileText').innerText;

      this.consensoService.saveFissoRequest(this.consentsWithAdditionalProperty);
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: this.isConsentsOk,
          consents: this.consentsWithAdditionalProperty,
          phone: this.fisso.phone_number,
          linear: false,
          consensoType: 'fisso_request',
          htmlPage,
          textPage,
        },
      });
    }
  }

  private scrollOnInvalidElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }

  // Function to set valid OTP Verify button - General Condition Right Section
  getValidCheckboxesSecondPart(value) {
    this.checkboxGeneralCondition.checkboxConsents = value;
    if (value) {
      this.invalidGeneralCondition.consents = false;
    }

    if (
      this.checkboxGeneralCondition.checkboxConsents &&
      this.checkboxGeneralCondition.docsReceptionCondition &&
      this.checkboxGeneralCondition.supplyStartCondition &&
      this.checkboxGeneralCondition.generalCondition
    ) {
      this.goNextStep = true;
    } else {
      this.goNextStep = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-consent-fisso-request/alg-consent-fisso-request.ts